// Constants.
import * as ProfileConstants from 'constants/ProfileConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  isUpdated: false,
  profile: {},
};

export default function profile(state = initialState, action = {}) {
  switch (action.type) {
    case ProfileConstants.LOAD_PROFILE_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case ProfileConstants.LOAD_PROFILE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        isUpdated: false,
        profile: action.profile,
      };
    case ProfileConstants.LOAD_PROFILE_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        profile: {},
      };
    case ProfileConstants.UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        isUpdated: false,
        profile: action.profile,
      };
    case ProfileConstants.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        isUpdated: true,
        profile: action.profile,
      };
    case ProfileConstants.UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        isUpdated: false,
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        isUpdated: false,
        profile: {},
      };
    default:
      return state;
  }
}
